var exports = {
  "Vf": "MessageReactions.module__reactionsGrid___RS1VZE",
  "RW": "MessageReactions.module__reactionContainer___RS1VZE",
  "sU": "MessageReactions.module__reactionButton___RS1VZE",
  "I1": "MessageReactions.module__reactionMe___RS1VZE",
  "iX": "MessageReactions.module__reactionInner___RS1VZE",
  "Zg": "MessageReactions.module__emoji___RS1VZE",
  "Ps": "MessageReactions.module__countWrapper___RS1VZE",
  "lG": "MessageReactions.module__reactionContainerDisabled___RS1VZE",
  "II": "MessageReactions.module__reactionButtonDisabled___RS1VZE",
  "Go": "MessageReactions.module__reactionPickerButton___RS1VZE",
  "SD": "MessageReactions.module__reactionPickerButtonActive___RS1VZE",
};

module.exports = exports;
